import { useEffect, useState } from 'react';
import { demoRequestHref } from '@/content/site';
import { onWhatsAppAnchorClick } from '@/lib/tracking';
import './StickyCta.css';

export function StickyCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const sync = () => {
      if (!mq.matches) {
        setVisible(false);
        return;
      }
      const hero = document.getElementById('inicio');
      if (!hero) {
        setVisible(window.scrollY > 200);
        return;
      }
      setVisible(hero.getBoundingClientRect().bottom <= 80);
    };
    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    mq.addEventListener('change', sync);
    return () => {
      window.removeEventListener('scroll', sync);
      window.removeEventListener('resize', sync);
      mq.removeEventListener('change', sync);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="sticky-cta" aria-hidden={!visible}>
      <a
        href={demoRequestHref}
        className="btn btn-primary btn-block sticky-cta__btn"
        target="_blank"
        rel="noopener noreferrer"
        onClick={onWhatsAppAnchorClick('sticky_mobile', 'Hablar por WhatsApp')}
      >
        Hablar por WhatsApp
      </a>
    </div>
  );
}
